import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { ChatService } from "@app/core/services/chat.service";
import { MessageCenterService } from "@app/core/services/message-center.service";
import { RouteUrl } from '@app/core/utilities/route-url.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FindCRSService } from "@app/core";
import * as _ from 'lodash';
import { AuthenticationService } from '@app/core/services/authentication.service';

@Component({
  selector: "app-direct-messages",
  templateUrl: "./direct-messages.component.html",
  styleUrls: ["./direct-messages.component.scss"],
})
export class DirectMessagesComponent implements OnInit, OnDestroy {
  @Input() hasParent = false;
  @Output() closePopoverRef = new EventEmitter();
  @Output() openUserChat = new EventEmitter();
  @ViewChild("searchUSerTemplate") searchUSerTemplate: ElementRef;
  bsModalRef: BsModalRef;
  messageList = [];

  fullNamePlaceholderText = "Search Agent Name";
  locationPlaceholderText = "State, City or Zip";
  showAlertForLocation = false;
  showInvalidSearch = false;
  searchkwdName = "";
  searchkwdLocation = "";
  searchSubmitted = false;
  selectedAgentName = "";
  selectedLocationName = "";

  constructor(
    private messageCenterService: MessageCenterService,
    private sanit: DomSanitizer,
    private router: Router,
    public chatService: ChatService,
    private routeUrl: RouteUrl,
    private modalService: BsModalService,
    private _findcsrService: FindCRSService,
    private authService: AuthenticationService,
  ) { }

  ngOnInit() {
    this.getActiveChatList();
  }

  closePopover() {
    this.closePopoverRef.emit();
  }

  getActiveChatList() {
    this.chatService.SharedChatComponent.newMessageFound = false;
    this.chatService.getActiveUsersChat();
  }

  openChatWindow(id) {
    if (this.hasParent) {
      this.openUserChat.emit(id);
    } else {
      this.router.navigate([`user/direct/message/${id}`]);
    }
  }

  startConversation() {
    this.chatService.setuserArchiveChat();
    this.bsModalRef = this.modalService.show(
      this.searchUSerTemplate,
      Object.assign({}, { class: "modal-md" })
    );
  }

  ngOnDestroy() {
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanit.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  searchUser() {
    this.showAlertForLocation = false;
    this.showInvalidSearch = false;

    if (!this.searchkwdName && !this.searchkwdLocation) {
      this.searchSubmitted = true;
      this.showInvalidSearch = true;
      return;
    }

    if (
      this.searchkwdName.trim().length === 0 &&
      this.searchkwdLocation.trim().length === 0
    ) {
      this.showInvalidSearch = true;
      return;
    }

    // // Location Must be selected from auto complete search in case of search by name is blank
    if (
      this.searchkwdLocation !== "" &&
      this.selectedLocationName !== this.searchkwdLocation
    ) {
      if (!this.searchkwdName || this.searchkwdName.trim().length > 0) {
        this.showAlertForLocation = true;
        return;
      }
    }

    this.searchSubmitted = false;
    this.bsModalRef.hide();

    // this.router.navigateByUrl(
    //   "/" +
    //   this.routeUrl.agentResult +
    //   "?kwdName=" +
    //   this.searchkwdName.trim() +
    //   "&kwdLocation=" +
    //   this.searchkwdLocation.trim()
    // );

    this._findcsrService
      .searchAgents(this.searchkwdName, this.searchkwdLocation, 10)
      .subscribe(
        (x: any) => {
          const results = x;
          if (results != null && results.TotalResultCount > 0 && results.Members.length > 0) {
            const receiverId = +results.Members[0].ID;
            if (receiverId !== +this.authService.getUserInformation()["ID"]) {
            this.router.navigate([`user/direct/message/0`], {
              queryParams: {
                rid: receiverId,
              },
            });
          }
          }
        });
  }

  searchKeyWorkForName(keyWork: any) {
    this.searchkwdName = keyWork;
    if (this.searchkwdName) {
      if (this.searchkwdName.trim().length > 0) {
        this.searchSubmitted = false;
      }
    }
  }

  searchKeyWorkForLocation(keyWork: any) {
    this.searchkwdLocation = keyWork;
    if (this.searchkwdLocation) {
      if (this.searchkwdLocation.trim().length > 0) {
        this.searchSubmitted = false;
      }
    }

    // // this.showAlertForLocation = false;
    this.showInvalidSearch = false;
  }

  selectedItem(item: any, by: string = "") {
    if (by === "name") {
      this.selectedAgentName = item.item;
      this.searchkwdName = this.selectedAgentName;
    } else if (by === "location") {
      this.selectedLocationName = item.value;
      this.searchkwdLocation = this.selectedLocationName;

      this.showAlertForLocation = false;
      this.showInvalidSearch = false;
    }
  }

  hasFile(message) {
    return _.startsWith(message, "<Attechment") ? 'Attachment' : message;
  }
}

